import React from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import '../Assets/CSS/Sidebar.css';
import CloseIcon from "@mui/icons-material/Close";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutIcon from '@mui/icons-material/Logout';
import GroupsIcon from '@mui/icons-material/Groups';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import TrendingDownOutlinedIcon from '@mui/icons-material/TrendingDownOutlined';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';


export default function Sidebar({ open, handleDrawerToggle, userId, setUserId, userData, setUserData, walletAddress }) {

    const drawerWidth = 250;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [openDirect, setOpenDirect] = React.useState(false);
    const navigate = useNavigate();

    const handleDirectClick = () => {
        setOpenDirect(!openDirect);
    };

    const handleItemClick = () => {
        if (isMobile) {
            handleDrawerToggle();
        }
    };

    const handleLogout = () => {
        localStorage.removeItem("userId");
        localStorage.removeItem("userData");
        localStorage.removeItem("walletAddress")
        setUserId("");
        setUserData(null);
        navigate('/')
    };

    const DrawerList = (
        <Box
            sx={{ width: isMobile ? "90vw" : drawerWidth, px: 3 }}
            role="presentation"
        >
            <List sx={{ display: "flex", flexDirection: "column", gap: 1 }}>

                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/dashboard")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <DashboardIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Dashboard"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/bnbconnect")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <DashboardIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Buy BCC Token"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/buyreport")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <MonitorHeartIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Buy Report"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/downline")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <GroupsIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Downline Report"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/selltoken")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <TrendingDownOutlinedIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Sell BCC Token"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/sellreport")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <DashboardIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Sell Report"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/withdrawal")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <DashboardIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Withdrawal"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick()
                            navigate("/withdrareport")
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <RequestQuoteOutlinedIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Withdrawal Report"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleItemClick();
                            handleLogout();
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <LogoutIcon sx={{ color: "white" }} />
                        </ListItemIcon>
                        <ListItemText primary="Logout"
                            primaryTypographyProps={{
                                sx: {
                                    whiteSpace: "normal",
                                    wordBreak: "break-word"
                                }
                            }} />
                    </ListItemButton>
                </ListItem>

            </List>
        </Box>
    );

    return (
        <Box>
            {/* {isMobile && !open && (
                <IconButton
                    onClick={handleDrawerToggle}
                    sx={{ position: "fixed", top: 10, left: 10, zIndex: 1300 }}
                >
                    <MenuIcon />
                </IconButton>
            )} */}

            <Drawer
                variant={isMobile ? "temporary" : "permanent"}
                open={isMobile ? open : true}
                onClose={handleDrawerToggle}
                ModalProps={{
                    BackdropProps: {
                        sx: {
                            backgroundColor: "transparent"
                        }
                    }
                }}
                sx={{
                    "& .MuiDrawer-paper": {
                        width: isMobile ? "85vw" : drawerWidth,
                        boxSizing: "border-box",
                        background: "#232529",
                        color: "white",
                        overflowX: "hidden",
                        overflowY: "auto", // scroll if content is long
                        mt: "80px",
                    },
                }}
            >

                <Box sx={{ flexShrink: 0 }}>
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end", width: "100%",
                            }}
                        >
                            {isMobile && (
                                <IconButton onClick={handleDrawerToggle} sx={{ color: "white", cursor: "pointer" }}>
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </Grid>
                        <Grid item xs={12} md={12} sx={{ overflowY: "auto", overflowX: "hidden", width: "100%" }}>
                            {DrawerList}
                        </Grid>
                    </Grid>
                </Box>
            </Drawer>

        </Box>
    );
}